import React, {Component} from "react"
import {Route} from "react-router-dom"

import authentication from "@irati/auth"
import {IndexRedirect, PartialRoute} from "@irati/utils/history/routing"
import {LangLoader} from "@irati/utils/lang"
import AppContainer from "@irati/ui/src/AppContainer"
import {FIELDS} from "@irati-web/fields/index"
import {ACCOUNT, MEDICAL} from "@irati-web/app/src/routeConfig"

import theme from "@irati/ui/src/global/theme"

import Home from "../containers/Home"
import Reports from "../containers/MedicalReports"
import MedicalUpsell from "../containers/Home/MedicalUpsell/MedicalUpsell"

interface Props {
  path: string
}

export default class extends Component<Props> {
  indexRoute = () => (authentication.apps("medical") ? "/my-medical" : "/up-sell")

  render() {
    const {path} = this.props
    return (
      <LangLoader buckets={[MEDICAL, ACCOUNT, FIELDS]}>
        <Route
          path={path}
          render={() => (
            <AppContainer mainBackground={theme.colors.greys.white}>
                <>
                  <PartialRoute
                    permission="medical"
                    match={path}
                    exact
                    path="/my-medical"
                    component={Home}
                    title="My Medical" />
                  <PartialRoute
                    permission="medical.reports"
                    match={path}
                    exact
                    path="/reports"
                    component={Reports}
                    title="Reports" />
                  <PartialRoute
                    match={path}
                    exact
                    path="/up-sell"
                    component={MedicalUpsell}
                    title="Get Medical" />
                  <IndexRedirect match={{url: path}} to={this.indexRoute()} />
                </>
            </AppContainer>
          )} />
      </LangLoader>
    )
  }
}
